import React, {createRef} from "react"
import PropTypes from "prop-types"
import {findDOMNode} from "react-dom"

import MentionsManager from "../../../../gd/manager/mentions/mentions-manager"
import FieldsCollection from "../../../collection/base/fields-collection";
import RichTextEditorUniversal from "../../../../gd-components/editor-universal/editor-universal"
import { FieldType } from "../../../field-type"

// @ts-ignore
import FieldsFactory1 from "../../../../fields/fields-factory"

const DEFAULT_HEIGHT = 220

// const debug = "MessageEditor"
const debug = false

export default class FieldDescriptionEditor_Component extends React.Component<any,any> {

    public fieldsCollection : FieldsCollection
    public fieldsOptions    : any
    public node             : any
    public rte              : any = createRef()
    public rteNode          : any

    static propTypes = {
        field   : PropTypes.object,
        value   : PropTypes.any,

        disabled: PropTypes.bool,

        onChange: PropTypes.func
    }

    constructor(props:any) {
        super(props)

        this.fieldsCollection = new FieldsCollection(
            [
                {
                    fieldId: 'taskId',
                    label: 'Task ID',
                    type: FieldType.TASK_ID
                },
                {
                    fieldId: 'taskTitle',
                    label: 'Task title',
                    type: FieldType.TASK_TITLE
                },
                {
                    fieldId: 'taskProject',
                    label: 'Project',
                    type: FieldType.TASK_PROJECT
                },

                {
                    fieldId: 'taskTitleLink',
                    label: 'Task title',
                    type: FieldType.TASK_TITLE
                },

                {
                    fieldId: 'taskIdLink',
                    label: 'Task ID',
                    type: FieldType.TASK_ID
                },
            ]
        )

        let fieldsIds:any = [];
        _.mapKeys([
            gd.const.fields.type.TITLE,
            gd.const.fields.type.PRIORITY,
            gd.const.fields.type.SCHEDULE,
            gd.const.fields.type.DEADLINE,
            gd.const.fields.type.TASK_TYPE,
            gd.const.fields.type.DATE_CREATED,
            gd.const.fields.type.DATE_CLOSED,
            gd.const.fields.type.LAST_UPDATED,

            // status fields
            gd.const.fields.type.STATUS,

            //
            gd.const.fields.type.TASK_ID,
            gd.const.fields.type.USERS,
            gd.const.fields.type.TAGS,
            gd.const.fields.type.ESTIMATE,
            gd.const.fields.type.ESTIMATE_MINUTES,
            gd.const.fields.type.ESTIMATE_HOURS,
            gd.const.fields.type.PROGRESS_BAR,
            gd.const.fields.type.PROGRESS_ITEMS,
            gd.const.fields.type.PROGRESS_PROJECT_TASKS,
            gd.const.fields.type.TIME_REPORTED,
            gd.const.fields.type.TIME_REPORTED_MINUTES,
            gd.const.fields.type.TIME_REPORTED_HOURS,
            gd.const.fields.type.CREATED_BY,
            gd.const.fields.type.ACTION_REQUIRED,
            gd.const.fields.type.ASSIGNED_TO,

            gd.const.fields.type.START_DATE,
            gd.const.fields.type.END_DATE,
            gd.const.fields.type.START_END_DATE,

            gd.const.fields.type.PROJECT,
            gd.const.fields.type.PROJECT_FULL_NAME,
            gd.const.fields.type.DURATION_CALENDAR_DAYS,
            gd.const.fields.type.DURATION_WORK_DAYS,
            gd.const.fields.type.SPENT_ESTIMATE,
            gd.const.fields.type.DEPENDS_ON,
            gd.const.fields.type.DEPENDANTS,
            gd.const.fields.type.STORY_POINTS,
            gd.const.fields.type.MESSAGES_TOTAL,
            gd.const.fields.type.ATTACHMENTS_TOTAL,

            gd.const.fields.type.COST_INTERNAL,
            gd.const.fields.type.COST_EXTERNAL,
            gd.const.fields.type.COST_EXPENSES,
        ], value=>{fieldsIds.push(value)})
        _.map(gd.session.customFields.filterByCompany(gd.companyId).models, cf=>{fieldsIds.push(cf.id)})

        this.fieldsOptions = [];
        _.map(fieldsIds, id=>{
            const field = FieldsFactory1.get(id);
            if (field) this.fieldsOptions.push({id, field})
        });
    }

    componentDidMount() {
        this.node       = findDOMNode(this)
        this.rteNode    = findDOMNode(this.rte.current)

        this.rteNode.style.setProperty('min-height', '{0}px'.f(DEFAULT_HEIGHT))

        this.updateHeight()
    }

    onAddFieldClick = (fieldId:string) => {

        const field = this.fieldsCollection.get(fieldId)

        switch (fieldId) {
            case 'taskTitleLink':
            case 'taskIdLink':
                this.rte.current.addLinkToEditor(field.variableName, '{TASK-URL}', ' ')
                break

            default:
                this.rte.current.addTextToEditor(field.variableName, ' ')
                break
        }

    }

    onKeyDown = () => {
        this.updateHeight()
    }

    onChange = (text:string, textRTF:any) => {
        debug && console.log(debug, "onChange", text, textRTF)
        if (this.props.onChange) this.props.onChange(text, textRTF)
    }

    updateHeight = () => {
        setTimeout(()=>{
            let newHeight = this.rteNode.offsetHeight

            debug && console.log(debug, "onKeyDown", this.rteNode, newHeight)

            if (newHeight < DEFAULT_HEIGHT) newHeight = DEFAULT_HEIGHT
            this.node.style.setProperty('height', '{0}px'.f(newHeight))
        }, 0)
    }

    render() {
        const classes = Classes("ui5-form-message-edit", {
            // 'no-fields-options': !this.props.field.showFieldsOptions
        })

        const addFieldConfig2 = {
            manageColumnsConfig: [
                {
                    value   : 'generic',
                    label   : 'Generic',
                    type    : 'system',
                    items: [
                        {fieldId: 'taskId',         label: 'Task',          icon: 'i5-task'},
                        {fieldId: 'taskTitle',      label: 'Task title',    icon: 'i5-text'},
                        {fieldId: 'taskProject',    label: 'Project',       icon: 'i5-project'},
                    ]
                },
                {
                    value   : 'task-links',
                    label   : 'Task Links',
                    type    : 'system',
                    items : [
                        {fieldId: 'taskTitleLink',  label: 'Task title',    icon: 'i5-text'},
                        {fieldId: 'taskIdLink',     label: 'Task id',       icon: 'i5-id'},
                    ]
                },
                // {
                //     groupId: 'custom',
                //     groupName: 'Custom',
                //     groupType: 'custom-fields',
                //     fields: customFieldIds
                // }
            ],
            fields      : this.fieldsCollection.all(),

            onAddField: this.onAddFieldClick
        }




        return (
            <div className={classes} style={{height: DEFAULT_HEIGHT}}>
                <div className="ui5-form-message-textarea ui5-bg-white">
                    <RichTextEditorUniversal ref                = {this.rte}
                                             // className           = {Classes('ui5-field-form-editable', this.props.className)}
                                             addField           = {addFieldConfig2}
                                             className          = {this.props.className}
                                             editable           = {!this.props.disabled}
                                             placeholder        = "Message"
                                             messageRTF         = {this.props.value}
                                             mentions           = {MentionsManager.getMentions({companyId: gd.companyId})}
                                             useLocalSettings   = {false}
                                             showControls       = {true}
                                             showSettingsButton = {false}
                                             stateSaveInterval  = {500}
                                             onKeyDown          = {this.onKeyDown}
                                             onChange           = {this.onChange}/>

                    {/*<RichTextEditor ref                 = {this.rte}
                                    // className           = {Classes('ui5-field-form-editable', this.props.className)}
                                    addField            = {addFieldConfig2}
                                    className           = {this.props.className}
                                    type                = {this.props.disabled ? "view" : "full"}
                                    editorType          = "default"
                                    placeholder         = "Message"
                                    rtfState            = {this.props.value}
                                    companyId           = {gd.companyId}
                                    mentions            = {MentionsManager.getMentions({companyId: gd.companyId})}
                                    useLocalSettings    = {false}
                                    showControls        = {true}
                                    showSettingsButton  = {false}
                                    stateSaveInterval   = {500}
                                    onKeyDown           = {this.onKeyDown}
                                    onChange            = {this.onChange}/>*/}
                </div>

            </div>
        )
    }

}
